<div fxLayout="row">
    <div fxFlex="93">
      <h1>{{ data.LastName }} {{ data.FirstName }}</h1>
      <h2>{{ data.Title | translate }}</h2>
    </div>
    <div fxFlex="7">
      <button mat-icon-button color="primary" (click)="onClose()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  
  <div fxLayout="column" fxLayoutGap="10px">
    <div class="header-wrapper"></div>
  
    <app-agreements-section
        [preSelectedAgreements]="preSelectedAgreementsArray"
        [disabledSelectedAgreements]="preSelectedAgreementsArray"
        [workerId]="data.WorkerId"
        (agreementsSelectionChange)="onAgreementsSelectionChange($event)">
    </app-agreements-section>

    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
      <button mat-raised-button (click)="onClose()">
        {{ 'Cancel' | translate }}
      </button>
      <button mat-raised-button color="primary" (click)="onAssingDocument()" [disabled]="!isAssignButtonEnabled()">
        {{ 'Save' | translate }}
      </button>
    </div>
  </div>
